import { atom } from 'recoil'

export const WarningMessage = atom<string | undefined>({
  key: 'warningMessageAtom',
  default: undefined,
})
